import script from "./CustomTag.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomTag.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__